import React from 'react';
import styles from './index.scss';

var Error = () => /*#__PURE__*/React.createElement("div", {
  className: styles.centered
}, /*#__PURE__*/React.createElement("div", {
  className: styles.emoji
}, "\uD83D\uDE2D"), /*#__PURE__*/React.createElement("p", {
  className: styles.title
}, "Ooooops!"), /*#__PURE__*/React.createElement("p", null, "This page does not exist anymore."));

export default Error;